import { SET_LANG } from "../actions/types";

const reducer = (state = "en", action) => {
  switch (action.type) {
    case SET_LANG:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
